import React, { createContext, useContext, useState, useEffect } from "react";

const SidebarContext = createContext({
  expanded: true,
  toggleExpanded: () => {},
  mobileOpen: false,
  setMobileOpen: () => {},
  toggleMobileOpen: () => {},
  closeMobile: () => {},
  openMobile: () => {},
  isMobileDrawer: false,
});

export function SidebarProvider({ children }) {
  const [expanded, setExpanded] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  function getExpand() {
    let locExp = localStorage.getItem("expand");
    if (locExp !== null) {
      try {
        setExpanded(JSON.parse(locExp));
      } catch (e) {
        setExpanded(true);
      }
    } else {
      localStorage.setItem("expand", true);
      setExpanded(true);
    }
  }

  useEffect(() => {
    getExpand();
  }, []);

  function toggleExpanded(e) {
    const val = e !== undefined ? e : !expanded;
    setExpanded(val);
    localStorage.setItem("expand", val);
  }

  function toggleMobileOpen() {
    setMobileOpen((prev) => !prev);
  }

  function closeMobile() {
    setMobileOpen(false);
  }

  function openMobile() {
    setMobileOpen(true);
  }

  return (
    <SidebarContext.Provider
      value={{
        expanded,
        setExpanded: toggleExpanded,
        toggleExpanded,
        mobileOpen,
        setMobileOpen,
        toggleMobileOpen,
        closeMobile,
        openMobile,
        isMobileDrawer: false,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  return useContext(SidebarContext);
}

export { SidebarContext };
